import {Injectable} from '@angular/core';
import {EntityState, SignalEntityStore} from '../../state/signal-entity.store';
import {Question} from '../../models/underwriter.model';

export interface QuestionState extends EntityState<Question> {
}

@Injectable({providedIn: 'root'})
export class QuestionStore extends SignalEntityStore<Question, QuestionState> {
  constructor() {
    super({name: 'flow-questions', idKey: 'cent_aq_question_id'});
  }
}
